export default __webpack_public_path__ + "static/human-rights-mobile-banner-2ee576be02c20940c6e7cc9dcb0e4623.png";